import { render } from "./login-panel.vue?vue&type=template&id=6b8da76e&scoped=true"
import script from "./login-panel.vue?vue&type=script&lang=js"
export * from "./login-panel.vue?vue&type=script&lang=js"

import "./login-panel.vue?vue&type=style&index=0&id=6b8da76e&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8da76e"]])

export default __exports__